import { ComplianceReportDescription, ComplianceReportEnum } from "@herbjoy/apex-api-models";

export class ComplianceReport {
    reportFlags: ComplianceReportEnum[];
    names: string[];
    allowManualDateRange: boolean;
    /**
     * Construct a compliance report definition from an enum of values.
     * @param {complianceReport} reportFlags A flag containing the composite compliance reports.
     */
    constructor(reportFlags: number[], reportDescriptions: ComplianceReportDescription[]) {
        const reports = reportDescriptions.filter(p => reportFlags.some(q => q === p.Value));
        this.reportFlags = reports.map(p => p.Id);
        this.names = reports.map(p => p.Name);
        this.allowManualDateRange = this._allowManualDateRange();
    }

    /**
     * Return whether the compliance report consists of any reports that can
     * be allow the user to specify a freeform date range.
     */
    _allowManualDateRange() {
        return [
            ComplianceReportEnum.SplitPay,
            ComplianceReportEnum.NoMealBreak,
            ComplianceReportEnum.MealBreakBelow30Min,
            ComplianceReportEnum.SecondMealBreak,
            ComplianceReportEnum.RecordedTimeSecondShiftBelow2Hour,
            ComplianceReportEnum.MealBreakTooEarlyOrLate,
            ComplianceReportEnum.SeventhDayOfRest,
            ComplianceReportEnum.RecordedTimeLapseBelow5Min,
            ComplianceReportEnum.RecordedTimeLapse5to60Min,
            ComplianceReportEnum.RecordedTimeLapseAbove60Min,
            ComplianceReportEnum.Worked7WorkDaysInRow,
            ComplianceReportEnum.NoWorkHoursWithMealBreak,
            ComplianceReportEnum.OverlappingTimeEntries,
            ComplianceReportEnum.IncompleteTimeEntries,
            ComplianceReportEnum.FirstMealBreakReport,
            ComplianceReportEnum.AllTimeRecordsReport,
            ComplianceReportEnum.RSCostcoReport,
            ComplianceReportEnum.AdditionalHoursReport
        ].some(p => this.reportFlags.some(q => q === p));
    }
}
